"use client";

import { FC, memo, useMemo } from "react";
import { ReactSVG, Props } from "react-svg";
import { useRuntimeConfig } from "@finbackoffice/site-core";
import { formatAppNameText } from "@finbackoffice/fe-core";
import { CircleLoader } from "../circle-loader/CircleLoader";

const Loader = () => <CircleLoader />;

type IProps = Pick<Props, "className" | "src" | "onClick"> & {
    loader?: boolean;
    testId?: string;
    prefixAppName?: boolean;
};

// https://github.com/tanem/react-svg/issues/1545
const SvgComponent: FC<Omit<IProps, "ref">> = ({
    loader,
    src,
    className,
    onClick,
    testId,
    prefixAppName = false,
}) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");

    const fullSrc = useMemo(() => {
        if (!src) return "";

        let nextSrc = src;

        if (prefixAppName) {
            nextSrc = `/${formatAppNameText(COMMON_SITE_CONFIGS.appName)}${nextSrc}`;
        }

        return `${ASSETS_URL}${nextSrc}`;
    }, [ASSETS_URL, COMMON_SITE_CONFIGS.appName, prefixAppName, src]);

    const loading = useMemo(() => (loader ? Loader : undefined), [loader]);

    return (
        <ReactSVG
            wrapper="span"
            src={fullSrc}
            className={className}
            onClick={onClick}
            loading={loading}
            data-testid={testId}
        />
    );
};

export const Svg = memo(SvgComponent);
